export function deteteById(id, arr) {
  if (id >= 0 && arr) {
    const newArr = [];
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].id !== parseInt(id)) {
        newArr.push(arr[i]);
      }
    }
    return newArr;
  } else {
    return arr;
  }
}

export function sortByField(arr, field) {
  const newArr = [];
  let wasSorted = false;

  for (let i = arr.length; i--;) {
    if (arr[i][field]) {
      wasSorted = true;
      newArr[parseInt(arr[i][field])] = arr[i];
    }
  }

  if (wasSorted) {
    return newArr;
  } else {
    return arr;
  }
}

export function findByField(id, arr, value) {
  for (let i = arr.length; i--;) {
    if (arr[i][value] == id) {
      return arr[i];
    }
  }
  return null;
}

export function getLastId(arr) {
  if (arr && arr.length > 0) {
    const tempObj = {};
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].id !== undefined) {
        tempObj[parseInt(arr[i].id)] = '';
      }
    }
    return parseInt(Object.keys(tempObj).slice(-1)[0]);
  }

  return 0;
}



// WEBPACK FOOTER //
// ./src/utils/arrObj.js